import { useCustomerReduced } from '@/core/domain/people/Customers/Customers.hooks';
import { CustomerReduced } from '@/core/domain/people/Customers/Customers.types';
import { useDisclosure } from '@/hooks';
import { Form, InputProps } from 'antd';
import { useEffect } from 'react';
import CustomersSelectedModal from '../CustomersSelectedModal';
import InputSearch from '../InputSearch';
import { FaUserPlus } from 'react-icons/fa';
import AntdFeatherIcon from '../AntdFeatherIcon';
import CustomerSimplifiedRegisterModal from '@/components/Customers/CustomerSimplifiedRegisterModal';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';

type Props = InputProps & {
  onCustomerSelect: (customer: CustomerReduced) => void;
  fieldNameId: string;
  buttonSearchDisabled?: boolean;
  showCreateButton?: boolean;
};

const CustomerInputSearch: React.FC<Props> = ({
  onCustomerSelect,
  fieldNameId,
  buttonSearchDisabled = false,
  showCreateButton = false,
  ...props
}) => {
  const [modalOpened, modalAction] = useDisclosure();
  const [modalCreateCustomerOpened, modalCreateCustomerAction] =
    useDisclosure();

  const form = Form.useFormInstance();
  const customerId = Form.useWatch(fieldNameId, form);

  const { mutateAsync: getCustomer, isLoading } = useCustomerReduced();

  useEffect(() => {
    if (customerId) {
      getCustomer(customerId).then((customer) =>
        form.setFieldValue('customerName', customer.name),
      );
    }
  }, [customerId]);

  return (
    <>
      <InputSearch
        {...props}
        inputProps={{ disabled: true }}
        buttonProps={{
          onClick: modalAction.open,
          loading: isLoading,
          disabled: buttonSearchDisabled,
        }}
        secondaryButtonProps={
          showCreateButton && !buttonSearchDisabled
            ? {
                onClick: modalCreateCustomerAction.open,
                title: !hasPermissions([Authorities.REGISTER_CUSTOMER_ADD])
                  ? 'Você não tem permissão para cadastrar um cliente'
                  : 'Cadastro rápido de cliente',
                icon: <AntdFeatherIcon icon={<FaUserPlus />} size={16} />,
                disabled: !hasPermissions([Authorities.REGISTER_CUSTOMER_ADD]),
              }
            : undefined
        }
      />

      <CustomersSelectedModal
        handleVisible={modalAction.close}
        visible={modalOpened}
        onCustomerSelect={(customer) => {
          onCustomerSelect(customer);
          modalAction.close();
        }}
        noSelection
      />

      {showCreateButton && (
        <CustomerSimplifiedRegisterModal
          visible={modalCreateCustomerOpened}
          handleVisible={modalCreateCustomerAction.close}
          onFinishCallback={(customer) => {
            onCustomerSelect(customer);
            modalCreateCustomerAction.close();
          }}
        />
      )}
    </>
  );
};

export default CustomerInputSearch;
